var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading.fullscreen.lock",
          value: _vm.fullscreenLoading,
          expression: "fullscreenLoading",
          modifiers: { fullscreen: true, lock: true }
        }
      ],
      staticClass: "log-box"
    },
    [
      _c(
        "el-dialog",
        { attrs: { "before-close": _vm.closeBox, visible: true } },
        [
          _c(
            "el-table",
            {
              staticStyle: { width: "100%" },
              attrs: { data: _vm.list, height: "250" }
            },
            [
              _c("el-table-column", {
                attrs: { fixed: "", prop: "event", label: "事件" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "content", label: "内容" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "admin_name", label: "操作人" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "create_time", label: "操作时间" }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-476f4140", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-476f4140","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/purchasegroup/components/Log.vue
// module id = null
// module chunks = 